import { Helmet } from 'react-helmet-async';
// @mui
import {
    Card,
    Stack,
    Container,
    Typography,
    TableContainer, CardContent, Button, CircularProgress, Box,
} from '@mui/material';

import {useNavigate, useParams} from 'react-router-dom';

// components
import Scrollbar from '../components/scrollbar';
// sections
import { StepByStepTable } from "../sections/@dashboard/attestations";
import {GeneralLayout} from "../layouts/GeneralLayout";
import Label from "../components/label";
import TextField from "@mui/material/TextField";
import {useEffect, useState} from "react";
import {useGetNextAttestationNumberQuery, usePostCreateAttestationMutation} from "../store/attestation/attestationApi";
import PageTitle from "../components/PageTitle";
import {useGetFacultiesQuery} from "../store/faculty/facultyApi";
import MenuItem from "@mui/material/MenuItem";
import {useAttendanceMonitoringReportMutation} from "../store/reports/reportsApi";

export default function AttendanceMonitoringReportPage() {
    const {id} = useParams();
    const navigate = useNavigate();
    const [isSaving, setIsSaving] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [refresh, setRefresh] = useState(false);
    const {data: facultiesData} = useGetFacultiesQuery();
    const [selectedFacultyId, setSelectedFacultyId] = useState(null);
    const [educationFormId, setEducationFormId] = useState(null);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [loadDataRequest] = useAttendanceMonitoringReportMutation();

    function formatDate(dateObj) {
        return `${dateObj.getFullYear()}-${withZero(dateObj.getMonth() + 1)}-${withZero(dateObj.getDate())}`;
    }

    function applyVisualChanges() {
        setRefresh(!refresh);
    }

    function toDateString(date){
        if (date === null || date === undefined)
            return '';

        return new Date(date).toLocaleDateString("ru-RU");
    }

    function withZero(num) {
        return num < 10 ? `0${num}` : num;
    }

    const handleLoadData = async () => {
        if (!startDate) {
            alert('Укажите начало периода');
            return;
        }
        
        if (!endDate) {
            alert('Укажите конец периода');
            return;
        }
        
        setIsLoading(true);
        
        fetch(`/Reports/AttendanceMonitoringReport?fromDate=${startDate}&toDate=${endDate}&facultyId=${selectedFacultyId ?? 0}&educationFormId=${educationFormId ?? 0}`,
        {
                method: "GET",
                headers: {
                    "semesterid": localStorage.getItem("selectedSemesterId"),
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${localStorage.getItem('token')}`
            }
        }).then(response => {
            setIsLoading(false);
            return response.blob();
        }).then(response => {
            if (response.size < 1024*0) { // отсекаем все, что ниже 0кб
                alert('Не удалось загрузить файл')
                return;
            }

            const url = window.URL.createObjectURL(
                new Blob([response]),
            );
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute(
                'download',
                `Мониторинг посещаемости ${formatDate(new Date(startDate))} - ${formatDate(new Date(endDate))}.xlsx`,
            );

            // Append to html link element page
            document.body.appendChild(link);

            // Start download
            link.click();

            // Clean up and remove the link
            link.parentNode.removeChild(link);
        }).catch((e) => {
            setIsLoading(false);
            alert('Ошибка');
        })
    };

    return (
        <GeneralLayout>
            <PageTitle title={`Мониторинг посещаемости`} />

            <Container>
                <Stack direction="column"
                       padding="120px 0px 0px 100px"
                       spacing={2}>
                    <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
                        <Typography variant="h4" gutterBottom>
                            Мониторинг посещаемости
                        </Typography>
                    </Stack>

                    <Card>
                        <CardContent>
                            <Stack spacing={2}>
                                <Stack direction="row" spacing={2} alignItems="center">
                                    <Typography fontWeight={'bold'}>Дата</Typography>
                                    <TextField size={'small'}
                                               onChange={(event) => setStartDate(event.target.value)}
                                               type={'date'} />
                                    <Typography fontWeight={'bold'}>-</Typography>
                                    <TextField size={'small'}
                                               onChange={(event) => setEndDate(event.target.value)}
                                               type={'date'} />
                                </Stack>
                                
                                <TextField select
                                           label="Факультет"
                                           onChange={(event) => setSelectedFacultyId(event.target.value)}
                                           defaultValue={0}
                                           size={'small'}>
                                    <MenuItem value={0}>Все</MenuItem>
                                    {facultiesData?.data?.map((faculty) =>
                                        <MenuItem key={faculty.key} value={faculty.key}>{faculty.value}</MenuItem>
                                    )}
                                </TextField>

                                <TextField select
                                           label="Форма обучения"
                                           onChange={(event) => setEducationFormId(event.target.value)}
                                           defaultValue={0}
                                           size={'small'}>
                                    <MenuItem value={0}>Все</MenuItem>
                                    <MenuItem value={1}>Заочная</MenuItem>
                                    <MenuItem value={2}>Очная</MenuItem>
                                    <MenuItem value={3}>Очно-заочная</MenuItem>
                                </TextField>
                                
                                <Button variant="contained" onClick={handleLoadData} disabled={isLoading}>
                                    {isLoading ? <CircularProgress size={24} /> : 'Печать'}
                                </Button>
                            </Stack>
                        </CardContent>
                    </Card>

                    <br />
                </Stack>
            </Container>
        </GeneralLayout>
    );
}